import config from './config';
import { createAuth } from '@justgiving/auth';

export const auth = createAuth({
  documentOrReq: document,
  authCookieName: config.AUTH_COOKIE_NAME,
  activeGroupCookieName: config.AUTH_ACTIVE_GROUPS_COOKIE_NAME,
  refreshAccessTokenUrl: config.AUTH_REFRESH_URL,
});
